/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
/* eslint-disable no-shadow */
import "emoji-mart/css/emoji-mart.css";

import {
  CheckCircleOutlined,
  ExceptionOutlined,
  HistoryOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Card,
  Col,
  DatePicker,
  Dropdown,
  List,
  Menu,
  message as antmessage,
  Modal,
  Row,
  Space,
  Spin,
  Table,
  Tabs,
  Tooltip,
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";

import {
  getModerationQueue,
  getUserModerationHistory,
} from "../../lib/queries";
import { getSupaClient } from "../../lib/supabase";

const teamId = localStorage.getItem("team-id");
const { TabPane } = Tabs;

const defaultTimeFormat = "YYYY-MM-DDTHH:mm:ssZ";
const dateFormat = "YYYY-MM-DD";

const Moderation = () => {
  const supabase = getSupaClient();
  const [loading, setLoading] = useState(true);
  const [startTime, setStartTime] = useState(
    moment().subtract(7, "d").format(defaultTimeFormat)
  );
  const [endTime, setEndTime] = useState(moment().format(defaultTimeFormat));
  // const [moderationQueue, setModerationQueue] = useState([])
  // all moderation items will be in this object. TODO: Modify this when people start using this more frequently
  const [moderationQueue, setModerationQueue] = useState([]);
  const [toReviewReported, setToReviewReported] = useState([]);
  const [reviewedReported, setReviewedReported] = useState([]);
  const [violationsCounts, setViolationCounts] = useState([]);
  const [currentUserActivity, setCurrentUserActivity] = useState(null);

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current > moment().endOf("day");
  };

  /**
   * Purpose: prepare violation counts from moderation queue
   * Params: moderation results
   */
  const prepareViolationCounts = (results) => {
    // get unique members in the results arrays
    const uniqueMembers = results
      .map((item) => item.slack_user?.slack_id)
      .filter((value, index, self) => self.indexOf(value) === index);
    // for each member find the counts and return a new array
    const violationArray = uniqueMembers.map((member) => {
      let count = 0;
      let slackUser = {};
      results.forEach((record) => {
        if (record.slack_user?.slack_id == member) {
          count += 1;
          slackUser = record.slack_user;
        }
      });
      return {
        key: member,
        count,
        slackUser,
      };
    });
    // console.log("unique", uniqueMembers, violationArray);
    violationArray.sort((a, b) => b.count - a.count);
    setViolationCounts(violationArray);
  };

  const loadModeration = async () => {
    const params = {
      team: String(teamId),
    };
    const results = await getModerationQueue(params);
    const reviewed = results.filter((result) => result.status == "Reviewed");
    const toReview = results.filter((result) => result.status == null);
    setModerationQueue(results);
    setToReviewReported(toReview);
    setReviewedReported(reviewed);
    // prepare violation counts
    prepareViolationCounts(results);
  };

  const loadPageData = async (startTime, endTime) => {
    loadModeration();
    setLoading(false);
  };

  useEffect(() => {
    loadPageData(startTime, endTime);
  }, []);

  const changeDates = async (startTime, endTime) => {
    setLoading(true);
    console.log("date changed", startTime, endTime);
    // setDate(date)
    setStartTime(startTime);
    setEndTime(endTime);
    loadPageData(startTime, endTime);
    setLoading(false);
  };

  const [datePickerText, setDatePickerText] = useState("Past 7 days");

  function handleMenuClick(e) {
    console.log("click", e);
    if (e.key == 1) {
      antmessage.info("Loading..");
      changeDates(
        moment().subtract(1, "day").format(defaultTimeFormat),
        moment().format(defaultTimeFormat)
      );
      setDatePickerText("Past 24 hours");
    }
    // past 7 days
    else if (e.key == 2) {
      antmessage.info("Loading..");
      changeDates(
        moment().subtract(7, "day").format(defaultTimeFormat),
        moment().format(defaultTimeFormat)
      );
      setDatePickerText("Past 7 days");
    }
    // past 30 days
    else if (e.key == 3) {
      antmessage.info("Loading..");
      changeDates(
        moment().subtract(30, "day").format(defaultTimeFormat),
        moment().format(defaultTimeFormat)
      );
      setDatePickerText("Past 30 days");
    }
    // custom
    else if (e.key == 4) {
      console.log("custom", startTime, moment(startTime, dateFormat));
      setDatePickerText("Select range");
    }
  }
  // data changed
  const [isModalVisible, setIsModalVisible] = useState(false);
  // eslint-disable-next-line prettier/prettier
  const [userActivityModalVisible, setUserActivityModalVisible] =
    useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setDatePickerText(
      `${moment(startTime).format(dateFormat)} - ${moment(endTime).format(
        dateFormat
      )}`
    );
    setIsModalVisible(false);
  };

  const dateChanged = async (date, dateString) => {
    setLoading(true);
    console.log(
      date,
      dateString,
      date[0].format(defaultTimeFormat),
      moment().format(defaultTimeFormat),
      moment().subtract(7, "day").format(defaultTimeFormat)
    );
    setStartTime(date[0]);
    setEndTime(date[1]);
    await loadPageData(
      date[0].format(defaultTimeFormat),
      date[1].format(defaultTimeFormat)
    );
    setDatePickerText(
      `${moment(startTime).format(dateFormat)} - ${moment(endTime).format(
        dateFormat
      )}`
    );
    setLoading(false);
  };
  window.analytics.track("Open moderation");

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="1">Past 24 hours</Menu.Item>
      <Menu.Item key="2">Past 7 days</Menu.Item>
      <Menu.Item key="3">Past 30 days</Menu.Item>
      <Menu.Item key="4" onClick={showModal}>
        Custom
      </Menu.Item>
    </Menu>
  );

  const loadUserActivity = async (slackId) => {
    const results = await getUserModerationHistory(slackId);
    setCurrentUserActivity(results);
  };

  const markDone = async (message) => {
    // console.log("message", message);
    const { data } = await supabase
      .from("spam_msgs")
      .update({ status: "Reviewed" })
      .match({ reported_message_id: message.reported_message_id });
    window.analytics.track("Review moderation task");
    // removeMessage(message)
    if (data) {
      antmessage.success("Marked Reviewed!");
      loadUserActivity(message.slack_user);
      loadPageData();
    }
  };

  const violationColumns = [
    {
      title: "Member",
      dataIndex: "slackUser",
      width: "15%",
      render: (text, record) => (
        <Row>
          <Col span={6}>
            <Avatar src={record.slackUser.image_32} />
          </Col>
          <Col span={18}>
            <Row>
              <a
                onClick={() => showUserActivityModal(record.slackUser.slack_id)}
              >
                {record.slackUser.name}
              </a>
            </Row>
          </Col>
        </Row>
      ),
    },
    {
      title: "Counts",
      dataIndex: "count",
      width: "8%",
    },
  ];

  const columns = [
    {
      title: "Reported",
      dataIndex: "ageText",
      sorter: (a, b) => {
        return a.ageSeconds - b.ageSeconds;
      },
      width: "8%",
      render: (text, record) => (
        <div>
          {record.ageText}
          {!record.direct_message ? (
            <Tooltip title="Click to open in slack">
              <a href={record.permalink} target="_blank" rel="noreferrer">
                <img
                  alt="Link"
                  width="16"
                  className="pt-0.5"
                  src="/external-link.svg"
                />
              </a>
            </Tooltip>
          ) : null}
        </div>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "8%",
      render: (text, record) => (
        <div>
          {text} ({record.direct_message ? "Private" : "Public"} message)
        </div>
      ),
    },
    {
      title: "Additional info from member",
      dataIndex: "reported_text",
      width: "10%",
    },
    {
      title: "Member",
      dataIndex: "slack_user",
      width: "15%",
      render: (text, record) => (
        <Row>
          <Col span={6}>
            <Avatar src={record.slack_user.image_32} />
          </Col>
          <Col span={18}>
            <Row>
              <a
                onClick={() =>
                  showUserActivityModal(record.slack_user.slack_id)
                }
              >
                {record.slack_user.name}
              </a>
            </Row>
          </Col>
        </Row>
      ),
    },
    {
      title: "Message",
      dataIndex: "text",
      width: "30%",
    },
    {
      title: "Reported by",
      dataIndex: "reported_by",
      width: "10%",
      render: (text, record) => <p>{record.reported_by.name}</p>,
    },
    {
      title: "Message time",
      dataIndex: "ageText",
      sorter: (a, b) => {
        return a.ageSeconds - b.ageSeconds;
      },
      width: "5%",
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 150,
      render: (text, record) => (
        <Space direction="vertical">
          {!record.status ? (
            <Tooltip title="Mark as done if an appropriate action was taken">
              <Button
                onClick={() => markDone(record)}
                size="small"
                icon={<CheckCircleOutlined />}
                style={{
                  background: "#beec95",
                }}
              >
                Mark reviewed
              </Button>
            </Tooltip>
          ) : (
            ""
          )}
          <Tooltip title="View member violation history">
            <Button
              onClick={() => showUserActivityModal(record.slack_user.slack_id)}
              size="small"
              icon={<HistoryOutlined />}
            >
              Member history
            </Button>
          </Tooltip>
        </Space>
      ),
    },
  ];

  const showUserActivityModal = async (slackId) => {
    setUserActivityModalVisible(true);
    loadUserActivity(slackId);
  };

  const cancelUserActivityModal = () => {
    setUserActivityModalVisible(false);
  };

  return (
    <div>
      <Spin spinning={loading}>
        <Card>
          <Tabs defaultActiveKey="1">
            <TabPane
              tab={
                <span>
                  <UnorderedListOutlined />
                  To review
                </span>
              }
              key="1"
            >
              <Table
                size="small"
                dataSource={toReviewReported}
                columns={columns}
                scroll={{ x: 1300 }}
                // rowSelection={{type: 'radio', ...rowSelection}}
              />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <CheckCircleOutlined />
                  Reviewed
                </span>
              }
              key="2"
            >
              <Table
                size="small"
                dataSource={reviewedReported}
                columns={columns}
                scroll={{ x: 1300 }}
                // rowSelection={{type: 'radio', ...rowSelection}}
              />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <ExceptionOutlined />
                  Violations count
                </span>
              }
              key="3"
            >
              <Row justify="center">
                <Col span={12}>
                  <Table
                    size="small"
                    dataSource={violationsCounts}
                    columns={violationColumns}
                  />
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </Card>
        <Modal
          width={700}
          title="Member activity"
          style={{ top: 40, right: 10 }}
          visible={userActivityModalVisible}
          onCancel={cancelUserActivityModal}
          footer={[
            <Button key="submit" onClick={cancelUserActivityModal}>
              Cancel
            </Button>,
          ]}
        >
          {currentUserActivity ? (
            <Space>
              <List
                style={{ width: "600px" }}
                dataSource={currentUserActivity}
                renderItem={(item) => (
                  <List.Item>
                    <List.Item.Meta
                      // avatar={<Avatar src={item.image_32? item.image_32: '/avatar_slack.png'} />}
                      title={`${item.ageText} ago | ${item.type} | Reported by: ${item.reported_by.name}`}
                      description={
                        <>
                          <p>
                            Message ({item.channelName}): {item.text}
                            {item.permalink ? (
                              <Tooltip title="Click to open in slack">
                                <a
                                  href={item.permalink}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <img
                                    alt="Link"
                                    width="16"
                                    className="pt-0.5"
                                    src="/external-link.svg"
                                  />
                                </a>
                              </Tooltip>
                            ) : null}
                          </p>
                          <p>
                            {item.reported_text
                              ? `Additional info from member that reported: ${item.reported_text}`
                              : ""}
                          </p>
                        </>
                      }
                    />
                    <div>
                      {item.status ? (
                        item.status
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <Tooltip title="Mark as done if an appropriate action was taken">
                            <Button
                              onClick={() => markDone(item)}
                              size="small"
                              style={{
                                background: "#b5d6f4",
                                marginBottom: 10,
                              }}
                            >
                              Mark as Reviewed
                            </Button>
                          </Tooltip>
                        </div>
                      )}
                    </div>
                  </List.Item>
                )}
              />
            </Space>
          ) : (
            <Spin />
          )}
        </Modal>
      </Spin>
    </div>
  );
};

export default Moderation;
